import React, { useEffect, useState } from 'react';

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  src?: string;
  alt?: string;
  errorSrc?: string;
  className?: string;
  style?: React.CSSProperties;
};

const PLACEHOLDER_IMG = `${process.env.PUBLIC_URL}/img-placeholder.png`;

const Image: React.FC<ImageProps> = ({ src, errorSrc, ...rest }) => {
  const [imageSrc, setImageSrc] = useState(src || PLACEHOLDER_IMG);

  const onError = () => {
    if (imageSrc !== PLACEHOLDER_IMG) {
      setImageSrc(PLACEHOLDER_IMG);
    }
  };

  useEffect(() => {
    setImageSrc(src || PLACEHOLDER_IMG);
  }, [src]);

  return (
    <img src={imageSrc} onError={onError} alt={rest.alt ?? src} {...rest} />
  );
};

export default Image;
